import { CoopApiService, UserApiService } from '@aipb/gulliver/personal-content/data-access';
import { SendMessageDialogService } from '@aipb/gulliver/personal-content/dialog';
import { CoopSummaryResponse } from '@aipb/gulliver/personal-content/model';
import { inject, Injectable } from '@angular/core';
import { filter, finalize, mergeMap, Observable, tap } from 'rxjs';
import { GetCoopSummaryParams } from '../../api';
import { MessageRepository } from './message.repository';

@Injectable()
export class MessageService {
  private repository = inject(MessageRepository);
  private api = inject(CoopApiService);
  private sendMessageDialog = inject(SendMessageDialogService);
  private userApi = inject(UserApiService);

  fetchMessages(filters: Record<string, string[]> = {}) {
    this.repository.setLoading(true);
    return this.api.messageList(filters).pipe(
      tap((data) => {
        this.repository.setMessages(data.list);
        this.repository.setFilters(data.filters);
      }),
      finalize(() => {
        this.repository.setLoading(false);
      })
    );
  }

  public getCoopSummary(params: GetCoopSummaryParams = {}): Observable<CoopSummaryResponse> {
    return this.userApi.getCoopSummary(params).pipe(
      tap((data) => {
        this.repository.setCoopSummary(data);
      })
    );
  }

  sendMessageToCollection(message: string, uniqueId: string) {
    return this.api.messageSend({
      msgValue: message,
      receiverCollection: uniqueId
    });
  }

  sendMessageToUserDialog(userId: string) {
    return this.sendMessageDialog.open$().pipe(
      filter((message) => !!message),
      mergeMap((message) =>
        this.api.messageSend({
          msgValue: message,
          receiverUser: userId
        })
      )
    );
  }

  sendMessageToCollectionDialog(uniqueId: string) {
    return this.sendMessageDialog.open$().pipe(
      filter((message) => !!message),
      mergeMap((message) =>
        this.api.messageSend({
          msgValue: message,
          receiverCollection: uniqueId
        })
      )
    );
  }
}
